import React from "react";
import { Link } from "react-router-dom";
import { Wine, Instagram, Mail, Lock } from "lucide-react";

export default function ComingSoon() {
  return (
    <div className="min-h-screen relative overflow-hidden hero-radial grain" data-testid="coming-soon-page">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1607622750671-6cd9a99eabd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwY29ja3RhaWwlMjBwcmVwYXJhdGlvbnxlbnwwfHx8fDE3ODM5MzE1MTV8MA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/70 to-background" />
      </div>

      <div className="min-h-screen flex flex-col">
        <header className="max-w-7xl w-full mx-auto px-6 md:px-10 py-8 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center text-primary">
              <Wine size={20} strokeWidth={1.5} />
            </span>
            <div className="leading-none">
              <div className="font-display text-xl tracking-tight">Pinkies Up</div>
              <div className="overline text-[9px] text-primary/80 mt-1">Mobile Cocktail Bar</div>
            </div>
          </div>
          <Link
            to="/admin/login"
            className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-muted-foreground hover:text-primary transition-colors"
            data-testid="admin-access-link"
          >
            <Lock size={12} /> Admin
          </Link>
        </header>

        <main className="flex-1 flex items-center">
          <div className="max-w-4xl mx-auto px-6 md:px-10 py-16">
            <div className="flex items-center gap-2 mb-8">
              <span className="h-px w-10 bg-primary" />
              <span className="overline text-primary">Coming Soon</span>
            </div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05] font-light animate-fade-up">
              Something delicious
              <br />
              is <span className="italic text-primary">on the way</span>.
            </h1>
            <p
              className="mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed animate-fade-up"
              style={{ animationDelay: "120ms" }}
            >
              Pinkies Up is a mobile cocktail bar for weddings, private parties, and
              unforgettable evenings. We're putting the final touches on our website —
              in the meantime, get in touch and we'll be delighted to plan your event.
            </p>

            <div
              className="mt-12 flex flex-col sm:flex-row items-start gap-4 animate-fade-up"
              style={{ animationDelay: "220ms" }}
            >
              <a
                href="mailto:pinkiesupcocktailbar@gmail.com"
                className="inline-flex items-center gap-3 rounded-full px-7 py-4 bg-primary text-primary-foreground font-medium tracking-wide hover:bg-primary/90 transition-colors pink-glow"
                data-testid="coming-soon-email"
              >
                <Mail size={16} /> Get in touch
              </a>
              <a
                href="https://instagram.com/pinkie.up.cocktails"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-3 rounded-full px-7 py-4 border border-white/15 text-foreground/90 hover:border-primary/40 hover:text-primary transition-colors"
                data-testid="coming-soon-instagram"
              >
                <Instagram size={16} /> Follow @Pinkie.Up.Cocktails
              </a>
            </div>
          </div>
        </main>

        <footer className="hairline">
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between text-xs text-muted-foreground">
            <div>&copy; {new Date().getFullYear()} Pinkies Up</div>
            <div className="tracking-widest uppercase">Crafted with cocktails</div>
          </div>
        </footer>
      </div>
    </div>
  );
}
